<template>
  <section>
    <!--工具条-->
    <el-col :span="4" class="toolbar">
      <el-button type="primary" size="small" @click="showAddForm">新增</el-button>
    </el-col>

    <el-table :data="tableData"
              v-loading="listLoading">
      <el-table-column
        label="一级分类"
        prop="fname"
        align="center">
        <template scope="scope">
          <div v-if="scope.row.fid === -1 || scope.row.fid === '-1'">全部分类</div>
          <div v-else>{{scope.row.fname}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="二级分类"
        prop="sec_name"
        align="center">
        <template scope="scope">
          <div v-if="scope.row.sec_id === -1 || scope.row.sec_id === '-1'">全部分类</div>
          <div v-else>{{scope.row.sec_name}}</div>
        </template>
      </el-table-column>
           <el-table-column
        label="品牌"
        prop="brand_name"
        align="center">
        <template scope="scope">
          <div v-if="scope.row.brand_id === -1 || scope.row.brand_id === '-1'">全部品牌</div>
          <div v-else>{{scope.row.brand_name}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="折扣"
        prop="coupon_discount"
        align="center">
      </el-table-column>
      <el-table-column
        label="优惠码"
        prop="coupon_value"
        align="center">
      </el-table-column>
      <el-table-column
        label="开始时间"
        prop="start_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="结束时间"
        prop="end_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="create_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="操作"
        prop="event_unique_key"
        align="center">
        <template scope="scope">
          <el-button :plain="true" type="danger" size="small" @click="showEditForm(scope.row)">修改</el-button>
          <el-button :plain="true" type="danger" size="small" @click="deleteDate(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog title="新增" v-model="addFormVisible">
      <el-form :model="addForm" label-width="150px" :rules="formRules" ref="addForm">
        <el-form-item label="一级分类" prop="fid">
          <el-select v-model="addForm.fid" placeholder="请选择" @change="selectFirstMenu">
            <el-option key="-1" label="全部分类" value="-1"></el-option>
            <el-option
              v-for="item in firstMenu"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级分类" prop="sec_id">
          <el-select v-model="addForm.sec_id" placeholder="请选择">
            <el-option key="-1" label="全部分类" value="-1"></el-option>
            <el-option
              v-for="item in secondMenu"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
                <el-form-item label="品牌" prop="brand_id">
          <el-select v-model="addForm.brand_id" placeholder="请选择">
            <el-option key="-1" label="全部品牌" value="-1"></el-option>
            <el-option
              v-for="item in brandMenu"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="折扣" prop="coupon_discount">
          <el-input v-model="addForm.coupon_discount" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="优惠码" prop="coupon_value">
          <el-input v-model="addForm.coupon_value" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="start_time">
          <el-date-picker
            v-model="addForm.start_time"
            type="datetime"
            placeholder="选择开始时间"
            size="small"
            format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="end_time">
          <el-date-picker
            v-model="addForm.end_time"
            type="datetime"
            placeholder="选择结束时间"
            size="small"
            format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="addSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" v-model="editFormVisible">
      <el-form :model="editForm" label-width="150px" :rules="formRules" ref="editForm">
        <el-form-item label="一级分类" prop="fid">
          <el-select v-model="editForm.fid" placeholder="请选择" @change="selectFirstMenu">
            <el-option key="-1" label="全部分类" value="-1"></el-option>
            <el-option
              v-for="item in firstMenu"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级分类" prop="sec_id">
          <el-select v-model="editForm.sec_id" placeholder="请选择">
            <el-option key="-1" label="全部分类" value="-1"></el-option>
            <el-option
              v-for="item in secondMenu"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
 <el-form-item label="品牌" prop="brand_id">
          <el-select v-model="editForm.brand_id" placeholder="请选择">
            <el-option key="-1" label="全部品牌" value="-1"></el-option>
            <el-option
              v-for="item in brandMenu"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="折扣" prop="coupon_discount">
          <el-input v-model="editForm.coupon_discount" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="优惠码" prop="coupon_value">
          <el-input v-model="editForm.coupon_value" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="start_time">
          <el-date-picker
            v-model="editForm.start_time"
            type="datetime"
            placeholder="选择开始时间"
            size="small"
            format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="end_time">
          <el-date-picker
            v-model="editForm.end_time"
            type="datetime"
            placeholder="选择结束时间"
            size="small"
            format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="editSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import config from '../../config';
  import {formatPara} from '../../static/js/util.js';

  export default {
    data() {
      return {
        tableData: [],
        total:0,
        page:1,
        pageSize:15,
        listLoading: false,
        query: '',
        submitLoading: false,
        addFormVisible: false,
        addForm: {
          fid: '-1',
          sec_id: '-1',
          brand_id:'-1',
          coupon_discount: '',
          coupon_value: '',
          start_time: '',
          end_time: '',
          create_time: '',
          status: 0
        },
        editFormVisible: false,
        editForm: {},
        formRules: {},
        firstMenu: [],
        secondMenu: [],
        allMenu: [],
        brandMenu:[]
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getList(this.query);
      },
      getList(query) {
        this.listLoading = true;
        this.$axios.post(config.api_url + '/couponcode/page', {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'warning'
          });
        })
      },
      addSubmit() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = formatPara(Object.assign({}, this.addForm));
              para.sort = parseInt(para.sort);
              para.fid = parseInt(para.fid);
              para.sec_id = parseInt(para.sec_id);
              para.brand_id = parseInt(para.brand_id);
              para.coupon_discount = parseFloat(para.coupon_discount);
              //异步请求
              this.$axios.post(config.api_url + '/couponcode',
                para).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['addForm'].resetFields();
                  this.addFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      editSubmit() {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = formatPara(Object.assign({}, this.editForm));
              para.sort = parseInt(para.sort);
              para.fid = parseInt(para.fid);
              para.sec_id = parseInt(para.sec_id);
               para.brand_id = parseInt(para.brand_id);
              para.coupon_discount = parseFloat(para.coupon_discount);
              //异步请求
              this.$axios.put(config.api_url + '/couponcode',
                para).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['editForm'].resetFields();
                  this.editFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      deleteDate(id) {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.delete(config.api_url + '/couponcode/' + id
          ).then(response => {
            if(response.data.state) {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.search();
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              });
            }
          }).catch(error => {
            this.$message({
              message: '删除异常，请联系管理员',
              type: 'error'
            });
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      showAddForm() {
        this.addFormVisible = true;
        this.addForm.coupon_value = Math.ceil(Math.random()*10000).toString();
      },
      showEditForm(row) {
        this.editFormVisible = true;
        this.editForm = row;
        if(row.fid === -1)
          this.editForm.fid = row.fid.toString();
        if(row.sec_id === -1)
          this.editForm.sec_id = row.sec_id.toString();

        if(row.brand_id === -1)
          this.editForm.brand_id = row.brand_id.toString();
        this.selectFirstMenu(row.fid);
      },
      //获取所有分类
      getAllMenu() {
        this.$axios.get(config.api_url + '/menu/tree'
        ).then(response => {
          let data = response.data;
          if(data && data.length > 0) {
            for(const item of data) {
              if(item.sec_menu && item.sec_menu.length > 0) {
                let secMenu = [];
                for(const item1 of item.sec_menu) {
                  secMenu.push({
                    label: item1.sec_name,
                    value: item1.sec_id
                  })
                }
                this.firstMenu.push({
                  label: item.fname,
                  value: item.fid,
                  children: secMenu
                })
              } else {
                this.firstMenu.push({
                  label: item.fname,
                  value: item.fid
                })
              }
            }
          } else {
            this.$message({
              message: '获取所有分类失败',
              type: 'error'
            });
          }
        }).catch(error => {
          this.$message({
            message: '获取所有分类异常，请联系管理员',
            type: 'error'
          });
        });
      },
      getBrandMenu() {
        this.$axios.get(config.api_url + '/brand/list').then(response => {
        console.log(response.data.msg);
          let data = response.data.msg;
          if (data && data.length > 0) {
            for (const item of data) {
              this.brandMenu.push({
                label: item.brand_name,
                value: item.brand_id
              });
            }
          } else {
            this.$message({
              message: '获取品牌失败',
              type: 'error'
            });
          }
        }).catch(error => {
          this.$message({
            message: '获取品牌异常，请联系管理员',
            type: 'error'
          });
        });
      },
      selectFirstMenu(val) {
        if(val === -1 || val === "-1") {
          this.secondMenu = [];
          this.editForm.sec_id = "-1";
        } else {
          for(const item of this.firstMenu) {
            if(item.value === val) {
              this.secondMenu = item.children;
            }
          }
        }
      }


    },

    created() {
      this.search();

      this.getAllMenu();
            this.getBrandMenu();


    }
  }
</script>



// WEBPACK FOOTER //
// CouponCode.vue?ce0d1c1e